import { useLayoutEffect } from 'react';
import { useThree } from '@react-three/fiber';

export function useInvalidateEveryRender() {
  const invalidate = useThree((state) => state.invalidate);
  useLayoutEffect(() => invalidate());
}

export function useAutoInvalidateOnChange(...dependencies: any[]) {
  const invalidate = useThree((state) => state.invalidate);

  useLayoutEffect(() => {
    invalidate();
  }, [invalidate, ...dependencies]); // eslint-disable-line react-hooks/exhaustive-deps
}
